import React, { useEffect, useState } from 'react'
import { httpAxios, fireClevertapEvent } from 'AccountsUtils'
import PageLoader from 'Lib/Pageloader'

import { CASE_HISTORY_MODAL_DETAIL, POST_CALL } from 'AccountsConstants/api_endpoints'
import Success from 'SVGPath/success.svg'
import RaiseComplaintDesktopModal from './RaiseComplaintDesktopModal'

import './RaiseComplaintModal.css'

const EscalationsModal = props => {
  const {
    complaintInput,
    showComplaintError,
    validateComplaint,
    message,
    isDirty,
    setIsDirty,
    setComplaintToggle
  } = props
  useEffect(() => {
    setIsDirty(false)
  }, [])
  return (
    <React.Fragment>
      <div className="pointer pt-6 pb-4" onClick={e => setComplaintToggle(false)}>
        <p className="pt-1 fs-14 fw-400 c-secondary-500">← All support requests</p>
      </div>
      <p className="py-2 fs-14 fw-400 c-neutral-700 pb-3">For support request <span>{`'${message}'`}</span></p>
      <div className="flex flex-center mt10">
        <textarea
          placeholder="Enter details of issue with resolution provided"
          rows={6}
          className={showComplaintError ? 'input-complaint error-input' : 'input-complaint'}
          onInput={e => validateComplaint(e.target.value)}
        >
          {complaintInput}
        </textarea>
      </div>
      {complaintInput === '' && isDirty && (
        <div className={showComplaintError ? 'error-message apr-20 pb-2' : 'error-message o-0'}>
          Please provide additional details for us to act on it.
        </div>
      )}
    </React.Fragment>
  )
}

const RaiseComplaintActionDesktop = props => {
  const {
    header,
    type,
    complaintToggle,
    modalContent,
    setComplaintToggle,
    setRefetchCases,
    callId,
    tripId,
    setHeader,
    setModalContent,
    setCallBackType,
    setDisableBg,
    isPWA
  } = props

  // const [showInputError, updateInputErrorFlag] = useState(false)
  const [showComplaintError, updateComplaintError] = useState(false)
  const [complaintInput, setComplaint] = useState('')
  const [isDirty, setIsDirty] = useState(false)
  const [complaintFlag, setComplaintFlag] = useState(false)
  const [loader, setLoader] = useState(false)

  useEffect(() => {
    setIsDirty(false)
    setComplaint('')
    updateComplaintError(false)
  }, [complaintToggle])

  useEffect(() => {
    if (type === 'complaint') {
      fireClevertapEvent('raise_complaint_shown', { trip_id: tripId })
    } else {
      fireClevertapEvent('Request_escalated_pop_up_shown', { trip_id: tripId })
    }
  }, [])

  const FulfillmentModal = ({ message, pwa }) => (
    <React.Fragment>
      <If condition={!pwa}>
        <div className="ta-c py-10">
          <Success fill="#46991A" />
        </div>
      </If>
      {/* <div className="amb-15 mb15 fs-24 ta-c fw-600">Request escalated</div> */}
      <div className="amb-15 mb15 fs-14 ta-c">{message}</div>
    </React.Fragment>
  )

  const validateComplaint = val => {
    setIsDirty(true)
    setComplaint(val)
    if (val) {
      updateComplaintError(false)
    } else {
      updateComplaintError(true)
    }
  }

  const primaryButtonConfig = {
    visible: true,
    text: 'Submit',
    action: (options, requestData, inputType) => {
      setIsDirty(complaintInput.length === 0)
      const payload = {
        callId,
        complaint: complaintInput,
        type
      }
      if (complaintInput !== '') {
        setLoader(true)
        httpAxios(CASE_HISTORY_MODAL_DETAIL + tripId, POST_CALL, payload)
          .then(resp => {
            fireClevertapEvent('raise_complaint_submit_clicked', { trip_id: tripId })
            setHeader(resp.data.header)
            setComplaintFlag(true)
            setLoader(false)
            setModalContent(resp.data.message)
            setCallBackType(resp.data.type)
          })
          .catch(() => {
            setComplaint('')
            setDisableBg(false)
            setLoader(false)
            setIsDirty(false)
            updateComplaintError(false)
            setComplaintToggle(false)
          })
      } else {
        updateComplaintError(true)
      }
      setComplaint('')
    }
  }
  const secondaryButtonConfig = {
    visible: true,
    text: 'Cancel',
    action: () => {
      fireClevertapEvent('raise_complaint_cancel_clicked', { trip_id: tripId })
      setComplaint('')
      setIsDirty(false)
      setDisableBg(false)
      updateComplaintError(false)
      setComplaintToggle(false)
    }
  }
  const successButtonConfig = {
    visible: true,
    text: 'Okay, got it',
    action: () => {
      if (complaintFlag) {
        fireClevertapEvent('My_issue_is_not_resolved_submit_clicked', { trip_id: tripId })
      } else {
        fireClevertapEvent('I_need_urgent_help_submit_clicked', { trip_id: tripId })
      }
      setComplaint('')
      if (isPWA) {
        setDisableBg(false)
      }
      setComplaintFlag(false)
      setIsDirty(false)
      updateComplaintError(false)
      setComplaintToggle(false)
      setRefetchCases(true)
    }
  }

  return (
    <React.Fragment>
      <If condition={loader}>
        <PageLoader title="Please wait" message="While we are processing." className={`${isPWA ? '' : 'modal-loader'}`} />
        <Else />
        <If condition={complaintToggle && type === 'complaint'}>
          <div className="desktop-modal-case">
            <RaiseComplaintDesktopModal
              content={(
                <EscalationsModal
                  complaintInput={complaintInput || ''}
                  showComplaintError={showComplaintError}
                  validateComplaint={validateComplaint}
                  message={header}
                  isDirty={isDirty}
                  setIsDirty={setIsDirty}
                  setComplaintToggle={setComplaintToggle}
                />
              )}
              primaryButton={primaryButtonConfig}
              secondaryButton={secondaryButtonConfig}
              header="Escalate request"
              type={type}
              isPWA={isPWA}
              onCloseModal={complaintToggle}
              setComplaintToggle={setComplaintToggle}
            />
          </div>
        </If>

        <If condition={complaintToggle && type === 'fulfillment'}>
          <div className="desktop-modal-case">
            <RaiseComplaintDesktopModal
              content={<FulfillmentModal message={modalContent} pwa={isPWA} />}
              successButton={successButtonConfig}
              header={header}
              type={type}
              isPWA={isPWA}
              onCloseModal={complaintToggle}
              setComplaintToggle={setComplaintToggle}
            />
          </div>
        </If>
      </If>
    </React.Fragment>
  )
}

export default RaiseComplaintActionDesktop
